export default __webpack_public_path__ + "static/media/Icon2.6a703596.png";